import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { mapyTileUrl } from '../lib/mapy.js';
export function MapPreview({ lat, lon, apiKey, texts, testIdPrefix, center, onPick, }) {
    const containerRef = React.useRef(null);
    const hasPoint = lat !== null && lon !== null;
    const viewLat = hasPoint ? lat : center?.lat;
    const viewLon = hasPoint ? lon : center?.lon;
    React.useEffect(() => {
        if (containerRef.current === null || viewLat === undefined || viewLon === undefined)
            return;
        const container = containerRef.current;
        let map;
        let cancelled = false;
        void import('leaflet').then((mod) => {
            const leaflet = mod.default;
            if (cancelled)
                return;
            map = leaflet
                /*
                 * Krok UXP3 (P2-16): kolecko mysi NEZOOMUJE. Rucni pruchod 10. 10. 2026
                 * rolovani stranky nad mapou v „Nové zakázce" oddalilo mapu z ulice na
                 * cely region — makler pritom chtel jen scrollovat formular.
                 * Zoom zustava na ovladacich (`zoomControl`) a `+`/`-` klavesnici;
                 * s Ctrl (`ctrlKey`) ho Leaflet pusti dal.
                 */
                .map(container, {
                attributionControl: true,
                zoomControl: onPick !== undefined,
                scrollWheelZoom: false,
            })
                .setView([viewLat, viewLon], hasPoint ? 16 : 12);
            if (apiKey !== '') {
                leaflet
                    .tileLayer(mapyTileUrl(apiKey), {
                    minZoom: 0,
                    maxZoom: 19,
                    tileSize: 256,
                    attribution: texts.mapyAttribution,
                })
                    .addTo(map);
            }
            else {
                leaflet
                    .tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    maxZoom: 19,
                    attribution: texts.osmAttribution,
                })
                    .addTo(map);
            }
            if (hasPoint) {
                leaflet
                    .circleMarker([lat, lon], {
                    radius: 8,
                    color: '#1d4ed8',
                    fillColor: '#3b82f6',
                    fillOpacity: 1,
                    weight: 2,
                })
                    .addTo(map);
            }
            if (onPick !== undefined) {
                map.on('click', (event) => {
                    onPick(event.latlng.lat, event.latlng.lng);
                });
            }
        });
        return () => {
            cancelled = true;
            map?.remove();
        };
    }, [lat, lon, hasPoint, viewLat, viewLon, apiKey, onPick, texts.mapyAttribution, texts.osmAttribution]);
    if (viewLat === undefined || viewLon === undefined) {
        return (_jsx("div", { className: "rh-map", "data-testid": `${testIdPrefix}-map-placeholder`, children: _jsx("p", { className: "rh-map__placeholder", children: texts.unavailable }) }));
    }
    return (_jsx("div", { className: "rh-map", "data-testid": `${testIdPrefix}-map`, role: "region", "aria-label": texts.regionLabel, children: _jsx("div", { ref: containerRef, className: "rh-map__frame" }) }));
}
//# sourceMappingURL=map-preview.js.map